// extracted by mini-css-extract-plugin
export default {"file-button":"styles_file-button__laRo6"};